export const NOTIFICATIONS = {
  emptyData: "Data is empty",
  selectOrderItem: "Select at least one order item",
  selectDelivery: "Select at least one delivery",
};
